export {
  BestTreatmentsBadge,
  BestTreatmentsBadgeStyle,
} from './BestTreatmentsBadge';
